import React from "react";
import { MessageCircle } from "lucide-react";
import { whatsappLink } from "@/api";

export const FloatingWhatsapp = ({ message }) => (
  <a href={whatsappLink(message)} target="_blank" rel="noreferrer"
    className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-2xl whatsapp-pulse hover:scale-110 transition"
    data-testid="floating-whatsapp-btn" aria-label="Chatta su WhatsApp">
    <MessageCircle className="w-7 h-7" />
  </a>
);
